import RenderData from "./partials/renderData";

const StepSix = () => {
  return <RenderData />;
};
export default StepSix;
